<div *ngIf="!readonly">
    <button [disabled]="isDisabled" (click)="sendingModal.show()" id="send" class="btn btn-primary" type="button"
            title="{{ 'COMMON_UI.FRAGEBOGEN.ANTRAG_VERSENDEN.VERSENDEN' | translate }}">
      {{ 'COMMON_UI.FRAGEBOGEN.ANTRAG_VERSENDEN.VERSENDEN' | translate }}
    </button>

    <div #sendingModal="bs-modal" bsModal class="modal fade" id="fragebogenSendDialog{{context}}" role="dialog" tabindex="-1">
        <div class="modal-dialog modal-lg modal-dialog-centered sending-fb-width">
            <div class="modal-content">
                <div class="modal-header">
                    <ng-container *ngIf="hasAttachments">
                        <h3 class="modal-title pull-left">{{ 'COMMON_UI.FRAGEBOGEN_SENDEN.WITH_ATTACHEMENTS.TITEL' | translate }}</h3>
                        <button (click)="onCanceling()" class="close pull-right" id="canceldeletedata{{context}}"
                                type="button">
                        </button>
                    </ng-container>
                    <ng-container *ngIf="!hasAttachments">
                        <h3 class="modal-title pull-left">{{ 'COMMON_UI.FRAGEBOGEN_SENDEN.WITHOUT_ATTACHEMENTS.TITEL' | translate }}</h3>
                        <button (click)="onCanceling()" class="close pull-right" id="canceldeletedata{{context}}"
                                type="button">
                        </button>
                    </ng-container>
                </div>
                <div class="modal-body">
                    <ng-container *ngIf="hasAttachments">
                      <div class="sending-fb-content">
                        <em
                          [class.icon-fi-warning]="true"
                          class="icon icon-svg">
                        </em>
                        <p class="sending-fb-text" [innerHTML]="'COMMON_UI.FRAGEBOGEN_SENDEN.WITH_ATTACHEMENTS.CONTENT' | translate"></p>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="!hasAttachments">
                        <p class="sending-fb-text" [innerHTML]="'COMMON_UI.FRAGEBOGEN_SENDEN.WITHOUT_ATTACHEMENTS.CONTENT' | translate"></p>
                    </ng-container>
                    <div class="d-flex flex-row p-2 justify-content-end mt-4">
                        <button (click)="onSending()" class="btn btn-primary mr-4"
                                type="button">
                            {{ 'COMMON_UI.FRAGEBOGEN_SENDEN.WEITER' | translate }}
                        </button>
                        <button (click)="onCanceling()" class="btn btn-default" type="button">
                            {{ 'COMMON_UI.FRAGEBOGEN_SENDEN.ABBRECHEN' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
